import { studentGuardianType } from '../../../../constants/types/student-type';
import instance from '../../../axios/utils.ts/instance';

export interface PutStudentFirstLoginRequest {
  password: string;
  password2: string;
  /** YYYY-MM-DD */
  birthday: string;
  englishName: string;
  gender: string;
  agreementServiceUsage: boolean;
  agreementPersonalInfo: boolean;
  guardianInfo?: Omit<studentGuardianType, 'id'>;
}

/**
 * 학생 최초 로그인 설정
 * @param params
 * @returns
 */
export const putStudentFirstLogin = async (
  params: PutStudentFirstLoginRequest,
) => {
  const result = await instance.put('/v1/user/student/first-login', params);
  return result.data.data;
};
